/**
 * @author bhouston / http://clara.io/
 *
 * Luminosity
 * http://en.wikipedia.org/wiki/Luminosity
 */

 import * as THREE from 'three'

THREE.LuminosityHighPassShader = {

  shaderID: "luminosityHighPass",

	uniforms: {

		"tDiffuse": { type: "t", value: null },
		"luminosityThreshold": { type: "f", value: 1.0 },
		"smoothWidth": { type: "f", value: 1.0 },
		"defaultColor": { type: "c", value: new THREE.Color( 0x000000 ) },
		"defaultOpacity":  { type: "f", value: 0.0 }

	},

	vertexShader: [

		require('./vert.glsl')

	].join("\n"),

	fragmentShader: [

		require('./frag.glsl')

	].join("\n")

};


// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/postprocessing/quad/luminosityhighpass/index.js